import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import ArticleNotificationUI from './UI'
import { getUserNews, markAsRead } from '../../store/actions/news-actions'
import {
  getTypeFromTags,
  shouldShowArticleNotification,
} from '../../pages/News/utils'

const ArticleNotification = ({ top, userNews, ...props }) => {
  const location = useLocation()

  const [articles, setArticles] = useState([])

  useEffect(() => {
    const { articles: _articles = [] } = userNews || {}
    setArticles(
      _articles.filter(
        ({ tags, acknowledged }) =>
          shouldShowArticleNotification(tags, location.pathname) &&
          !acknowledged,
      ),
    )
  }, [userNews, location.pathname])

  const handleClose = articleId =>
    props.markAsRead(articleId).then(() => props.getUserNews())

  if (!articles.length) return null
  return (
    <div style={{ margin: `${top ? `${top}px` : 0} 0 2rem 0` }}>
      {articles.map(({ id, header, body, modified, tags }) => (
        <ArticleNotificationUI
          key={id}
          type={getTypeFromTags(tags)}
          title={header}
          body={body}
          modified={modified}
          onClose={() => handleClose(id)}
        />
      ))}
    </div>
  )
}

ArticleNotification.propTypes = {
  top: PropTypes.number,
  userNews: PropTypes.object,
  getUserNews: PropTypes.func.isRequired,
  markAsRead: PropTypes.func.isRequired,
}

ArticleNotification.defaultProps = {
  top: 0,
  userNews: null,
}

const mapStateToProps = state => ({
  userNews: state.news.userNews,
})

const mapDispatchToProps = {
  getUserNews,
  markAsRead,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleNotification)
